$(document).ready(function() {
  btnDisabledTqgMj()
  btnEnabledTqgMj()
  loopingMfQualificationIds()
  conditionRemoveTqgMjField()

  $('.add_fields').click(function() {
    var timeout = null;

    clearTimeout(timeout);

    timeout = setTimeout(() => {
      enableSubmitTqgMjForm()
      conditionRemoveTqgMjField()
    }, 100);
  })

  function conditionRemoveTqgMjField() {
    $('.remove_fields').click(function() {
      var timeout = null;
      clearTimeout(timeout);

      timeout = setTimeout(() => {
        btnDisabledTqgMj()
      }, 100);
    })
  }

  function disabledSubmitTqgMjForm(major_id) {
    $(`.remove_field_tqg_mf_qualification_${major_id}`).click(function() {
      var timeout = null;

      var tqg_mf_qualification = $(this).parents('.nested-fields').find('.tqg_mf_qualification_id')
      var condition1 = tqg_mf_qualification.length == 0

      if (!condition1) {
        var data_confirm = confirm(I18n.t('global.notices.delete_permanently'))
        if (!data_confirm) {
          return data_confirm
        }

        var tqg_incentive_trip_id = tqg_mf_qualification.data('incentive-trip-id')
        var tqg_incentive_qualification_id = tqg_mf_qualification.data('incentive-qualification-id')
        var tqg_mf_qualification_id = tqg_mf_qualification.data('mf-qualification-id')
        deleteTqgMfQualification(tqg_incentive_trip_id, tqg_incentive_qualification_id, tqg_mf_qualification_id)
      }

      clearTimeout(timeout);

      timeout = setTimeout(() => {
        btnDisabledTqgMj()
      }, 100);
    })
  }

  function btnDisabledTqgMj() {
    var length_nested = $('div[class="nested-fields"]').length
    if (length_nested <= 0) {
      $('.btn-tqg-mf-qualifications').attr('disabled', true)
      $('.error-message-tqg-mf-qualifications').removeClass('d-none')
    }
  }

  function enableSubmitTqgMjForm() {
    var timeout = null;
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      btnEnabledTqgMj()
    }, 100);
  }

  function btnEnabledTqgMj() {
    var length_nested = $('div[class="nested-fields"]').length
    if (length_nested > 0) {
      $('.btn-tqg-mf-qualifications').removeAttr('disabled')
      $('.error-message-tqg-mf-qualifications').addClass('d-none')
    }
  }

  function deleteTqgMfQualification(tqg_incentive_trip_id, tqg_incentive_qualification_id, tqg_mf_qualification_id) {
    $.ajax({
      type: "DELETE",
      dataType:"json",
      data: { 'tqg_incentive_trip_id' : tqg_incentive_trip_id, 'tqg_incentive_qualification_id' : tqg_incentive_qualification_id,
              'tqg_mf_qualification_id' : tqg_mf_qualification_id },
      url: `/admin/tqg_incentive_trips/${tqg_incentive_trip_id}/tqg_incentive_qualifications/${tqg_incentive_qualification_id}/destroy_tqg_downline_qualification/${tqg_mf_qualification_id}`,
      success: function(response){
        if (response['message'] = 'success') {
          var mf_id = response['mf_id']
          $(`#tqg_mf_qualification_id_${mf_id}`).parent().remove()
          $.each($('input[type=hidden]'), function( index, value ) {
            if (value.value == mf_id) {
              value.remove()
            }
          });
        }
        btnDisabledTqgMj()
      }
    });
  }

  function loopingMfQualificationIds() {
    var tqg_mf_qualification_ids = $('.tqg_mf_qualification_id')
    var length_tqg_mf_qualification = tqg_mf_qualification_ids.length == 0
    if (!length_tqg_mf_qualification) {
      $.each(tqg_mf_qualification_ids, function( index, value ) {
        var major_id = value.dataset['mfQualificationId']
        disabledSubmitTqgMjForm(major_id)
      });
    }
  }
});